const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/plan/$planId/scope-refinement/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { backlogItemsDataSetFetchOptions } from '@/lib/queries/adaptive-planner/useFetchBacklogItemsDataSet';
import { backlogItemsFilterSearchSchema } from '@/lib/zod-schemas/backlogItemsFilterSearchSchema';
import { descendantItemFilterSearchSchema } from '@/lib/zod-schemas/descendantItemFilterSearchSchema';
import { itemFilterSearchSchema } from '@/lib/zod-schemas/itemFilterSearchSchema';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
const backlogSearchSchema = itemFilterSearchSchema.and(itemPanelSearchSchema).and(descendantItemFilterSearchSchema).and(backlogItemsFilterSearchSchema);
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/plan/$planId/scope-refinement/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(backlogSearchSchema),
  loader: async ({
    context: {
      queryClient
    },
    params: {
      planId
    }
  }) => {
    await queryClient.ensureQueryData(backlogItemsDataSetFetchOptions({
      planId
    }));
  }
});